import React from "react";
import { Compass, MapPin } from "lucide-react";
import { calculateDailySailing } from "@/lib/dailySailing";
import { getTranslationsForLanguage } from "@/i18n";

export default function RouteRecommendationCard({ location, weather, lang = "en" }) {
  const summary = calculateDailySailing(weather);
  const t = getTranslationsForLanguage(lang, "dailyBriefing").route;
  const safeDistance = summary.score >= 80 ? 14 : summary.score >= 62 ? 8 : summary.score >= 42 ? 4 : 0;
  const placeName = [location?.city, location?.country].filter(Boolean).join(", ") || t.fallbackPlace;
  const route = {
    status: safeDistance ? t.recommended : t.notRecommended,
    title: safeDistance ? t.coastalLoop(safeDistance) : t.harborChecks,
    text: safeDistance ? t.text(placeName) : t.unsafeText,
    boatNote: summary.wind > 18 || summary.wave > 1.4 ? t.experienced : t.relaxed,
  };

  return (
    <article className="rounded-[2rem] border border-border bg-card p-6 shadow-xl shadow-ocean/5">
      <div className="flex items-start justify-between gap-4">
        <div><p className="text-sm font-black uppercase tracking-[0.18em] text-primary">{t.eyebrow}</p><h3 className="mt-2 text-2xl font-black">{route.title}</h3></div>
        <Compass className="h-8 w-8 text-primary" />
      </div>
      <p className="mt-4 leading-7 text-muted-foreground">{route.text}</p>
      <div className="mt-5 rounded-2xl bg-background/70 p-4">
        <div className="flex items-center gap-2 font-black"><MapPin className="h-4 w-4 text-primary" /> {route.status}</div>
        <p className="mt-2 text-sm leading-6 text-muted-foreground">{route.boatNote}</p>
      </div>
    </article>
  );
}